import React, { useState } from 'react';
import { Card, Container, Accordion } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Route, Routes, Link, Navigate, useNavigate } from 'react-router-dom';

function FAQ() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const LVFrequentQuestions = () => {
    return (
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header><strong>Kā veikt meklēšanu?</strong></Accordion.Header>
          <Accordion.Body>
            <p>
              Pēc pieteikšanās dodieties uz sadaļu "Meklēšana", izvēlaties tabulu, kurā vēlaties
              meklēt, un ievadiet datus par karavīru, kuru vēlaties atrast.
            </p>
            <p>
              Meklēt iespējams gan pēc pilna vārda un/vai uzvārda, gan tā daļas. Piemēram,
              uzvārda ailītē ierakstot "Bērz", meklētājs atradīs gan Bērziņu, gan Kalnbērzu, gan
              Paberzu u. c. Ja vēlaties sašaurināt meklēšanu, ierakstiet daļu no dienesta vienības.
              Piemēram, ievadot uzvārdu vai tā daļu un pie dienesta vienības "7. Bauskas",
              meklētājs atradīs visus karavīrus ar tādu uzvārdu, kas dienējuši attiecīgajā vienībā.
            </p>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header><strong>Ko darīt, ja neizdodas karavīru atrast?</strong></Accordion.Header>
          <Accordion.Body>
            <p>
              Pirmā pasaules kara latviešu strēlnieku sarakstos ieteicams meklēt tikai pēc vārda
              un uzvārda, jo tajos dzimšanas dati parādās ļoti reti. Meklēšanā var pamainīt vārda
              un/vai uzvārda rakstību. Piemēram, vārds "Fridrihs" var būt pierakstīts gan kā
              "Frīdrihs", gan "Fridrichs".
            </p>
            <p>
              Ja arī pēc rakstības maiņas rezultāti nav pozitīvi, ļoti iespējams, šis karavīrs
              sarakstos nav atrodams.
            </p>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header><strong>Kur iegūt papildu informāciju par karavīra dienesta vienību?</strong></Accordion.Header>
          <Accordion.Body>
            <p>
              Vispārīga informācija par dienesta vienībām meklējama grāmatās un interneta
              resursos. Sīkāku informāciju jāmeklē Latvijas un ārvalstu atmiņu institūcijās (skat.
              nākamo jautājumu).
            </p>
            <p>
              Dažas no grāmatām un interneta vietnēm, kurās meklējama informācija par Pirmā
              pasaules kara latviešu strēlnieku bataljoniem (pulkiem):
            </p>
            <ol>
              <li>Valdis Bērziņš "Latviešu strēlnieki: drāma un traģēdija" (1995);</li>
              <li>Jānis Hartmanis "Aizmirstie karavīri: latviešu strēlnieki Ķekavas kaujā" (2009);</li>
              <li>Igors Vārpa "Latviešu karavīrs zem Krievijas impērijas, padomju Krievijas un PSRS karogiem" (2006);</li>
              <li>
                <a href="https://latviesustrelniekusaraksts.lv/Kaujas_darbiba/index.html"
                  style={{ color: 'blue', textDecoration: 'underline' }}
                  target="_blank"
                  rel="noopener noreferrer">
                  https://latviesustrelniekusaraksts.lv/Kaujas_darbiba/index.html
                </a>
              </li>
              <li>
                <a href="https://www.dveseluputenis.lv/lv/"
                  style={{ color: 'blue', textDecoration: 'underline' }}
                  target="_blank"
                  rel="noopener noreferrer">
                  https://www.dveseluputenis.lv/lv/
                </a>
              </li>
            </ol>
            <p>
              Dažas no grāmatām, kurās meklējama informācija par Otrā pasaules kara Latviešu
              SS leģiona vienībām:
            </p>
            <ol>
              <li>
                "Latviešu karavīrs Otrā pasaules kara laikā" (1972-1991), 11 sējumi;{' '}
                <a href="https://dvcv.org.lv/latviesu_karavirs_otra_pasaules_kara_laika"
                  style={{ color: 'blue', textDecoration: 'underline' }}
                  target="_blank"
                  rel="noopener noreferrer">
                  https://dvcv.org.lv/latviesu_karavirs_otra_pasaules_kara_laika
                </a>
              </li>
              <li>Arturs Silgailis "Latviešu leģions" (1962)</li>
              <li>Igors Vārpa "Latviešu karavīrs zem kāškrusta karoga" (2003)</li>
              <li>Indulis Kažociņš "Latviešu karavīri zem svešiem karogiem" (1999)</li>
            </ol>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header><strong>Kādas ir tālākās meklēšanas iespējas?</strong></Accordion.Header>
          <Accordion.Body>
            <p>
              Publiskā datubāze vairumā gadījumu ietver salīdzinoši nelielu informācijas apjomu,
              kas var kalpot kā meklēšanas sākumpunkts un virziens.
            </p>
            <p>
              Par Pirmā pasaules kara latviešu strēlniekiem un Otrā pasaules kara latviešu
              leģionāriem un viņu likteņiem papildu informāciju var meklēt citās Latvijas un ārvalstu
              atmiņu institūcijās. Informāciju par atmiņu institūcijām un citiem informācijas
              resursiem skat.{' '}
              <span
                style={{ color: '#0d6efd', cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => navigate('/future-reading')}
              >
                šeit
              </span>
            </p>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="4">
          <Accordion.Header><strong>Kā reģistrēties?</strong></Accordion.Header>
          <Accordion.Body>
            <p>
              Reģistrēšanās jeb pieteikšanās datubāzē notiek, izmanotojot Vienoto pieteikšanās moduli. Nospiežot uz pogas “Vienotā pieteikšanās”, tiek atvērts jauns logs, kurā iespējams izvēlēties sev ērtāko pieteikšanās rīku (e-parakstu, Smart-ID, banku identifikāciju u. c.). Pēc sekmīgas pieteikšanās atvērsies meklēšanas platforma.
            </p>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  };

  const ENFrequentQuestions = () => {
    return (
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header><strong>How do I perform a search?</strong></Accordion.Header>
          <Accordion.Body>
            <p>
              After logging in, go to the "Search" section, choose the table you want to search in,
              and enter the information about the soldier you wish to find.
            </p>
            <p>
              You can search either by full first name and/or surname, or by part of it. For example,
              entering "Bērz" in the surname field, the programme will return results such as
              Bērziņš, Kalnbērzs, Paberzs, etc. If you want to narrow your search further, enter
              part of the service unit. For example, by entering a surname (or part of it) and typing
              "7. Bauskas" in the unit field, the search will find all soldiers with that surname who
              served in that unit.
            </p>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header><strong>What should I do if I cannot find the soldier?</strong></Accordion.Header>
          <Accordion.Body>
            <p>
              In the First World War Latvian Riflemen lists, it is recommended to search only by
              first name and surname, as birth data appear rarely. You may try varying the spelling
              of the first name and/or surname.
            </p>
            <p>
              For example, the name "Fridrihs" may also appear as "Frīdrihs" or "Fridrichs".
            </p>
            <p>
              If the results remain unsuccessful even after adjusting the spelling, it is very likely
              that this soldier is not included in the lists.
            </p>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header><strong>Where can I find additional information about a soldier's unit?</strong></Accordion.Header>
          <Accordion.Body>
            <p>
              General information about military units can be found in books and online resources.
              More detailed information must be sought in Latvian or foreign memory institutions
              (see the next question).
            </p>
            <p>
              Examples of books and websites containing information on First World War Latvian
              Riflemen battalions (regiments):
            </p>
            <ol>
              <li>Valdis Bērziņš "Latviešu strēlnieki: drāma un traģēdija" (1995);</li>
              <li>Jānis Hartmanis "Aizmirstie karavīri: latviešu strēlnieki Ķekavas kaujā" (2009);</li>
              <li>Igors Vārpa "Latviešu karavīrs zem Krievijas impērijas, padomju Krievijas un PSRS karogiem" (2006);</li>
              <li>
                <a href="https://latviesustrelniekusaraksts.lv/Kaujas_darbiba/index.html"
                  style={{ color: 'blue', textDecoration: 'underline' }}
                  target="_blank"
                  rel="noopener noreferrer">
                  https://latviesustrelniekusaraksts.lv/Kaujas_darbiba/index.html
                </a>;
              </li>
              <li>
                <a href="https://www.dveseluputenis.lv/lv/"
                  style={{ color: 'blue', textDecoration: 'underline' }}
                  target="_blank"
                  rel="noopener noreferrer">
                  https://www.dveseluputenis.lv/lv/
                </a>
              </li>
            </ol>
            <p>
              Examples of books that contain information about the Second World War Latvian SS
              Legion units:
            </p>
            <ol>
              <li>
                "Latviešu karavīrs Otrā pasaules kara laikā" (1972–1991), 11 volumes;{' '}
                <a href="https://dvcv.org.lv/latviesu_karavirs_otra_pasaules_kara_laika"
                  style={{ color: 'blue', textDecoration: 'underline' }}
                  target="_blank"
                  rel="noopener noreferrer">
                  https://dvcv.org.lv/latviesu_karavirs_otra_pasaules_kara_laika
                </a>
              </li>
              <li>Arturs Silgailis "Latviešu leģions" (1962);</li>
              <li>Igors Vārpa "Latviešu karavīrs zem kāškrusta karoga" (2003);</li>
              <li>Indulis Kažociņš "Latviešu karavīri zem svešiem karogiem" (1999)</li>
            </ol>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header><strong>What are the next steps to get more information?</strong></Accordion.Header>
          <Accordion.Body>
            <p>
              This public database typically includes a limited amount of information, which can
              serve as a starting point for further research.
            </p>
            <p>
              Additional information on First World War Latvian Riflemen, Second World War
              Latvian Legionnaires, and their fates may be found in other Latvian and international
              memory institutions. Information about these institutions and other resources can be
              found.{' '}
              <span
                style={{ color: '#0d6efd', cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => navigate('/future-reading')}
              >
                here
              </span>
            </p>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="4">
          <Accordion.Header><strong>How to register?</strong></Accordion.Header>
          <Accordion.Body>
            <p>
              Registration or signing up for the database is done using the Single Sign-On module. By clicking the “Unified login” button, a new window will open where you can choose your preferred authentication tool (e-signature, Smart-ID, bank authentication, etc.). After a successful login, the search platform will open.
            </p>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  };

  return (
    <Container>
      <Card className="w-70 text-center p-4 shadow-lg rounded">
        <section className="mb-4 text-start">
          <h4>{t('Biežāk Uzdotie Jautājumi')}</h4>
          <div className="text-muted">
            {i18n.language === 'lv' ? <LVFrequentQuestions /> : <ENFrequentQuestions />}
          </div>
        </section>
        <section>
          <h4 className="text-start">{t('Kontakti')}</h4>
          <p className="text-muted text-start mb-1">
            {t('Atbildīgā institūcija')}: <a href="https://www.karamuzejs.lv/" className="text-decoration-none">Latvijas Kara muzejs</a>
          </p>
          <p className="text-muted text-start mb-0">
            {t('E-pasts saziņai')}: <a href="mailto:datubaze@karamuzejs.lv" className="text-decoration-none">datubaze@karamuzejs.lv</a>
          </p>
        </section>
      </Card>
    </Container>
  );
}

export default FAQ;